import { motion, useReducedMotion } from "framer-motion";
import { STATS } from "@/content/landing";

export function StatsBand() {
  const reduce = useReducedMotion();
  return (
    <section data-testid="landing-stats" className="relative w-full border-t border-border/60">
      <div className="relative mx-auto w-full max-w-6xl px-6 py-16">
        <div className="sema-grain relative overflow-hidden rounded-3xl border border-border/60 bg-[#0B1228] px-8 py-12 text-white sm:px-12">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-40 animate-pulse-glow"
            style={{ background: "radial-gradient(60% 90% at 15% 0%, rgba(91,120,229,0.35), transparent 60%)" }}
          />
          <div className="relative">
            <p className="mb-8 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-white/50">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#0FAE96]" />
              {STATS.eyebrow}
            </p>
            <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
              {STATS.items.map((s, i) => (
                <motion.div
                  key={s.label}
                  data-testid={`stat-${i}`}
                  initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.1 }}
                >
                  <div className="font-display text-4xl font-bold tracking-tight sm:text-5xl">
                    <span className="sema-gradient-text">{s.value}</span>
                  </div>
                  <div className="mt-2 font-body text-sm text-white/60">{s.label}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
